import React, { Fragment, useEffect, useState } from 'react';
//import { useNavigate } from "react-router-dom";
import { useUIMode } from "../hooks/useUIMode";
//import { UserContext } from "../UserContext";
//import { hasAnyPerm } from '../utils/uiUtils';
import { useTranslation } from 'react-i18next';
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { formatDateOnly } from '../utils/timeUtils';
import TemplateListView    from "./TemplateListView";
import SaasTenantAdminDetailsView from "./SaasTenantAdminDetailsView";
import SaasTenantAdminNewView     from "./SaasTenantAdminNewView";


const SaasTenantAdmin = () => {

  const { t }    = useTranslation(["common"]);
  //const { user } = useContext(UserContext);
  //const navigate = useNavigate();

  const { uiMode, setUIMode, objDetails, setObjDetails } = useUIMode('LIST');

  const PAGE_STATE_STORAGE_KEY = "SaasTenantAdmin.pageState";
  const defaultPageState = {
    searchTerms: null,
    sortCol: null,
    sortDir: null,
    perPage: 25,
    currPage: 1
  };

  const [pageState, setPageState] = useState(() => {
    try {
      const savedPageState = sessionStorage.getItem(PAGE_STATE_STORAGE_KEY);
      return savedPageState
        ? { ...defaultPageState, ...JSON.parse(savedPageState) }
        : defaultPageState;
    } catch (error) {
      return defaultPageState;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(PAGE_STATE_STORAGE_KEY, JSON.stringify(pageState));
  }, [pageState]);

/*
  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["???Access"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
*/


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      igcFieldName: 'name',
      name: t("I18N_Name"),
      sortable: true,
      sortField: 'name',
      grow: 2,
      cell: null
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 2.5,
      wrap: true
    },
    {
      name: t("I18N_SubsPlan"),
      selector: row => t("I18N_" + row.subsPlan),
      sortable: true,
      sortField: 'subsPlan',
      grow: 2
    },
    {
      name: t("I18N_Plan_start_date"),
      selector: row => formatDateOnly(row.planStartDate),
      sortable: true,
      sortField: 'planStartDate',
      grow: 1.5
    },
    {
      name: t("I18N_Plan_expiration_date"),
      selector: row => formatDateOnly(row.planExpireDate),
      sortable: true,
      sortField: 'planExpireDate',
      grow: 1.5
    },
    {
      name: t("I18N_Status"),
      selector: row => t("I18N_ST_" + row.status),
      sortable: true,
      sortField: 'status',
      grow: 2
    },
    {
      igcColumnType: 'DELETE',
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: null
    }
  ];

  // ----- END - Data Table stuff -----


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_PLATFORM_API}
                                                  apiObjName={'saas-tenants'}
                                                  listPageTitle={t("I18N_SaasTenant_Management")}
                                                  newObjTooltip={t("I18N_TIP_New_SaaS_tenant")}
                                                  searchTooltip={t("I18N_Search")}
                                                  deleteConfirmDialogTitle={t("I18N_SaaSTenant_delete_confirm")}
                                                  deleteObjTooltip={t("I18N_TIP_Delete_SaaS_tenant")}
                                                  tableColumns={tableColumns}
                                                  //deletePermission={'BuildingAdminGeneralDeleteAccess'}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState} onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <SaasTenantAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <SaasTenantAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default SaasTenantAdmin;
